import React from "react";
import { Typography } from "@material-ui/core";
import styles from "../styles";

function ADAContactBox() {
  const useStyles = styles;
  const classes = useStyles();

  return (
    <div style={{ flex: window.innerWidth >= 640 ? "0 0 45%" : "1 1 100%", minWidth: "250px" }}>
      <Typography className={classes.justBold}>
        Student Accommodations Office
      </Typography>
      <Typography style={{ wordBreak: "break-word" }}>
        Email: <a href="mailto:SAO@phoenix.edu" style={{ color: "inherit", textDecoration: "underline" }}>SAO@phoenix.edu</a>
      </Typography>
      <Typography>
        Phone: (602) 557-1157
      </Typography>
    </div>
  );
}

export default ADAContactBox;
